import genericsReducer from './reducers';

export { default as genericsSagas } from './sagas';
export { default as genericsTypes } from './types';
export { default as genericsActions } from './actions';

export default genericsReducer;
